/* 2026 WilderdijkDynamics. R22 SIMGASM: real linked-color product card preview.
   No cart/analytics events are synthesized; native Empire compare is updated per selected product. */
(function () {
  'use strict';
  var rows = new Set();
  var resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) { measure(entry.target); });
  }) : null;
  function find(el, selector) { return el ? el.querySelector(selector) : null; }
  function getItems(row) { return Array.from(row.children).filter(function (e) { return e.matches('a.wd-r21-grid-colors__item'); }); }
  function close(row) {
    var panel = find(row, '[data-wd-r22-popover]');
    var more = find(row, '[data-wd-r22-more]');
    if (panel) panel.hidden = true;
    if (more) more.setAttribute('aria-expanded', 'false');
  }
  function fillOverflow(row) {
    var panel = find(row, '[data-wd-r22-popover]');
    if (!panel) return;
    panel.innerHTML = '';
    getItems(row).filter(function (item) { return item.hidden; }).forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.hidden = false;
      clone.classList.remove('is-active');
      clone.setAttribute('data-wd-r22-clone', '');
      panel.appendChild(clone);
    });
  }
  function rowWidth(row) {
    var width = row.getBoundingClientRect().width || row.clientWidth || 0;
    if (width > 72) return width;
    var parent = row.parentElement;
    while (parent && width <= 72) {
      width = Math.max(width, parent.getBoundingClientRect().width || parent.clientWidth || 0);
      parent = parent.parentElement;
    }
    return width;
  }
  function measure(row) {
    if (!row || !row.isConnected || !row.classList.contains('wd-r21-grid-colors')) return;
    var items = getItems(row), more = find(row, '[data-wd-r22-more]');
    if (!items.length || !more) return;
    items.forEach(function (item) { item.hidden = false; });
    more.hidden = true;
    var width = rowWidth(row);
    if (!width) return;
    var style = getComputedStyle(row);
    var gap = parseFloat(style.gap || style.columnGap) || 0;
    var itemWidth = items[0].getBoundingClientRect().width || 34;
    var buttonWidth = more.getBoundingClientRect().width || itemWidth;
    var available = Math.max(0, width);
    var allFit = Math.floor((available + gap) / (itemWidth + gap));
    if (allFit >= items.length) { close(row); return; }
    // Reserve one swatch position for the +N bubble, without producing a second row.
    var show = Math.max(1, Math.min(items.length - 1, Math.floor((available + gap - buttonWidth - gap) / (itemWidth + gap))));
    items.forEach(function (item, i) { item.hidden = i >= show; });
    more.textContent = '+' + (items.length - show);
    more.setAttribute('aria-label', '+' + (items.length - show) + ' ' + (row.dataset.wdR22MoreLabel || 'Color'));
    more.hidden = false;
    var panel = find(row, '[data-wd-r22-popover]');
    // ResizeObserver can fire when a popover opens. Never dismiss a user-opened
    // color selector just because measurements run again.
    if (panel && !panel.hidden) fillOverflow(row);
  }
  function syncListViewLayout(card) {
    if (!card) return;
    var container = find(card, '.productitem__container');
    var info = find(card, '.productitem--info');
    var actions = find(card, '.productitem--actions');
    var row = find(card, '[data-wd-grid-linked-colors]');
    if (!container || !info || !row) return;
    var placeholder = find(info, '[data-wd-r26-row-placeholder]');
    if (!placeholder) {
      placeholder = document.createElement('span');
      placeholder.hidden = true;
      placeholder.setAttribute('data-wd-r26-row-placeholder', '');
      info.insertBefore(placeholder, row);
    }
    var isListView = !!card.closest('.productgrid-listview');
    var desktopList = isListView && window.matchMedia('(min-width: 1100px)').matches;
    // Newly injected cards may not be observed by the original Empire view guard.
    card.classList.toggle('wd-r19-card', !isListView);
    if (desktopList) {
      // Three-column desktop list: keep swatches with product information.
      if (row.parentElement !== info) info.appendChild(row);
      row.removeAttribute('data-wd-listview-moved');
      row.setAttribute('data-wd-listview-inline', '');
    } else if (isListView) {
      // Preserve the already approved mobile/tablet list layout.
      if (row.parentElement !== container) {
        if (actions) container.insertBefore(row, actions);
        else container.appendChild(row);
      }
      row.removeAttribute('data-wd-listview-inline');
      row.setAttribute('data-wd-listview-moved', '');
    } else {
      // Grid mode: restore the exact original Liquid position.
      if (row.parentElement !== info || row.previousElementSibling !== placeholder) {
        info.insertBefore(row, placeholder.nextSibling);
      }
      row.removeAttribute('data-wd-listview-moved');
      row.removeAttribute('data-wd-listview-inline');
    }
  }
  function syncAllLayouts(scope) {
    (scope || document).querySelectorAll('[data-wd-r19-card]').forEach(syncListViewLayout);
  }
  function remember(card) {
    if (card.wdR22Original) return card.wdR22Original;
    var info = find(card, '.productitem--info');
    var title = find(card, '.productitem--title a');
    var price = find(info, '.wd-r19-price-row');
    var rating = find(info, '.product__rating.rating');
    var stock = find(info, '.productitem__stock-level');
    var dispatch = find(info, '.wd-r19-dispatch');
    var compareScript = find(card, '[data-product-compare-data]');
    var compare = null;
    if (compareScript) { try { compare = JSON.parse(compareScript.textContent); } catch (_) { /* use original compare state */ } }
    card.wdR22Original = { title: title ? title.innerHTML : '', price: price ? price.innerHTML : '',
      rating: rating ? rating.outerHTML : '', stock: stock ? stock.outerHTML : '',
      dispatch: dispatch ? dispatch.outerHTML : '', compare: compare,
      url: (find(card, '[data-wd-grid-linked-colors]') || {}).dataset?.wdR22OriginalUrl || '' };
    return card.wdR22Original;
  }
  function renderSibling(card, selector, html, before) {
    var info = find(card, '.productitem--info');
    if (!info) return;
    var current = find(info, selector);
    if (current) { current.remove(); }
    if (html) {
      var template = document.createElement('template');
      template.innerHTML = html.trim();
      var node = template.content.firstElementChild;
      if (!node) return;
      var marker = find(info, before);
      if (marker) info.insertBefore(node, marker);
      else info.appendChild(node);
    }
  }
  function choose(row, originalItem) {
    var card = row.closest('[data-wd-r19-card]');
    if (!card) return;
    var data = null;
    if (originalItem.dataset.wdR22Product) {
      try { data = JSON.parse(originalItem.dataset.wdR22Product); } catch (_) { return; }
    }
    if (data && (!data.url || !data.title || !data.image)) {
      // Missing product media: use the actual product page instead of a deceptive partial preview.
      window.location.assign(originalItem.href); return;
    }
    var original = remember(card);
    var selectedId = originalItem.dataset.wdR22Id;
    if (row.dataset.wdR22SelectedId === selectedId) { close(row); return; }
    var checkbox = find(card, '[data-compare-checkbox]');
    // Uncheck through Empire's native handler, removing the previously selected product from compare.
    if (checkbox && checkbox.checked) checkbox.click();
    var active = data || original;
    var url = data ? data.url : original.url;
    var title = find(card, '.productitem--title a');
    var info = find(card, '.productitem--info');
    var price = find(info, '.wd-r19-price-row');
    if (title) { title.innerHTML = active.titleHtml || active.title; title.title = data ? data.title : title.textContent.trim(); title.setAttribute('aria-label', title.title); }
    if (price) price.innerHTML = data ? data.priceHtml : original.price;
    renderSibling(card, '.product__rating.rating', data ? data.ratingHtml : original.rating, '.productitem__stock-level, .wd-r19-dispatch');
    renderSibling(card, '.productitem__stock-level', data ? data.stockHtml : original.stock, '.wd-r19-dispatch');
    renderSibling(card, '.wd-r19-dispatch', data ? data.dispatchHtml : original.dispatch, '.productitem--description');
    var imageLink = find(card, '.productitem--image-link');
    var figure = find(card, '[data-product-item-image]');
    var preview = find(figure, '.wd-r22-preview-image');
    if (data && figure) {
      if (!preview) { preview = document.createElement('img'); preview.className = 'wd-r22-preview-image'; preview.loading = 'lazy'; figure.appendChild(preview); }
      preview.src = data.image; preview.alt = data.title; preview.hidden = false;
    } else if (preview) { preview.hidden = true; preview.removeAttribute('src'); }
    if (imageLink) imageLink.href = url;
    if (title) title.href = url;
    var detail = find(card, '.productitem--description a[data-product-page-link]');
    if (detail) detail.href = url;
    var selectedCta = find(card, '[data-wd-r22-cta]');
    if (selectedCta) {
      selectedCta.href = url;
      selectedCta.hidden = !data;
      // 2026 WilderdijkDynamics. 4.85. A sold-out linked color must open its OWN alternatives.
      // When returning to an available color, restore Empire's normal linked-product detail action.
      if (data && data.available === false) {
        selectedCta.textContent = selectedCta.dataset.wdR85SimilarLabel || 'Shop similar products';
        selectedCta.setAttribute('data-wd-r85-open', '');
        selectedCta.setAttribute('data-wd-r85-product-id', String(data.id));
        selectedCta.setAttribute('aria-haspopup', 'dialog');
      } else {
        selectedCta.textContent = selectedCta.dataset.wdR85DefaultLabel || 'Choose options';
        selectedCta.removeAttribute('data-wd-r85-open');
        selectedCta.removeAttribute('data-wd-r85-product-id');
        selectedCta.removeAttribute('aria-haspopup');
      }
    }
    // The native quick-buy button always belongs to the original product. Only a PDP link is shown for linked colors.
    card.classList.toggle('wd-r22-linked-selected', !!data);
    var compareInstance = card.wdR22CompareInstance;
    // Keep the embedded JSON in sync for lazily initialized/reinitialized Empire cards.
    var compareScript = find(card, '[data-product-compare-data]');
    if (compareScript && active.compare) compareScript.textContent = JSON.stringify(active.compare);
    if (compareInstance && active.compare) compareInstance.compareData = active.compare;
    row.querySelectorAll('.wd-r21-grid-colors__item').forEach(function (item) {
      var selected = item.dataset.wdR22Id === selectedId;
      item.classList.toggle('is-active', selected);
      if (selected) item.setAttribute('aria-current', 'true'); else item.removeAttribute('aria-current');
    });
    row.dataset.wdR22SelectedId = selectedId;
    // Keep the selected color first so it remains visible when the row overflows.
    row.insertBefore(originalItem, row.firstElementChild);
    measure(row);
  }
  function initialize(scope) {
    syncAllLayouts(scope || document);
    (scope || document).querySelectorAll('[data-wd-grid-linked-colors]').forEach(function (row) {
      var card = row.closest('[data-wd-r19-card]');
      if (card) syncListViewLayout(card);
      if (!rows.has(row)) {
        rows.add(row);
        if (resizeObserver) resizeObserver.observe(row);
      }
      measure(row);
    });
  }
  function measureAll() {
    syncAllLayouts(document);
    rows.forEach(function (row) {
      window.requestAnimationFrame(function () { measure(row); });
    });
  }
  document.addEventListener('click', function (event) {
    var more = event.target.closest('[data-wd-r22-more]');
    if (more) {
      event.preventDefault();
      var row = more.closest('[data-wd-grid-linked-colors]');
      if (!row) return;
      var panel = find(row, '[data-wd-r22-popover]');
      if (!panel) return;
      if (!panel.hidden) { close(row); return; }
      fillOverflow(row);
      panel.hidden = false;
      more.setAttribute('aria-expanded', 'true');
      return;
    }
    var swatch = event.target.closest('[data-wd-grid-linked-colors] a[data-wd-r22-id]');
    if (swatch) {
      var swatchRow = swatch.closest('[data-wd-grid-linked-colors]');
      if (!swatchRow) return;
      event.preventDefault();
      var origin = swatch.hasAttribute('data-wd-r22-clone') ? getItems(swatchRow).find(function (item) { return item.dataset.wdR22Id === swatch.dataset.wdR22Id; }) : swatch;
      if (origin) choose(swatchRow, origin);
      return;
    }
    document.querySelectorAll('[data-wd-r22-popover]:not([hidden])').forEach(function (panel) { close(panel.parentElement); });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') document.querySelectorAll('[data-wd-r22-popover]:not([hidden])').forEach(function (panel) { close(panel.parentElement); });
  });
  document.addEventListener('wd:product-card-view-changed', measureAll);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('[data-compare-toggle]')) {
      window.setTimeout(measureAll, 30);
      window.setTimeout(measureAll, 140);
    }
  });
  document.addEventListener('click', function (event) {
    var viewToggle = event.target.closest('[data-collection-view], .productgrid--view-trigger, .productgrid--layout-button');
    if (viewToggle) {
      window.setTimeout(measureAll, 30);
      window.setTimeout(measureAll, 140);
    }
  }, true);
  // Breakpoint changes alter the row's parent, not just its available width.
  window.addEventListener('resize', measureAll);
  window.addEventListener('load', function () { measureAll(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  // Collection filters and featured-product sections can inject product tiles without a section load event.
  new MutationObserver(function (changes) {
    changes.forEach(function (change) {
      change.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-wd-grid-linked-colors]')) initialize(node.parentElement || node);
        else if (node.querySelector && node.querySelector('[data-wd-grid-linked-colors]')) initialize(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
}());
